// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_43-0";
export var eligibilityCardNotEligible = "_43-1";